import { render } from "./AddUserView.vue?vue&type=template&id=04518ffa&scoped=true"
import script from "./AddUserView.vue?vue&type=script&lang=js"
export * from "./AddUserView.vue?vue&type=script&lang=js"

import "./AddUserView.vue?vue&type=style&index=0&id=04518ffa&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04518ffa"]])

export default __exports__